export const WHITE_BACKGROUND = 'whiteBackground'
export const GREY_BACKGROUND = 'greyBackground'
